import { useTranslation } from 'react-i18next';
import { pages } from '../data/pages';

export const useLocalizedPaths = () => {
  const { i18n } = useTranslation();

  const getLocalizedPath = (path, language = i18n.language) => {

    const [pathname, hash] = path.split('#');
    
    const normalizedPath = pathname.endsWith('/') ? pathname : `${pathname}/`;
    
    const page = pages.find(p => p.en === normalizedPath);
    
    let localizedPath;
    if (!page) {
      localizedPath = language === 'pl' ? `/pl${normalizedPath}` : normalizedPath;
    } else {
      localizedPath = page[language] || page.en;
    }
    
    return hash ? `${localizedPath}#${hash}` : localizedPath;
  };

  return { getLocalizedPath, currentLanguage: i18n.language };
};